<template>
  <div class="iframe-block" :style="{ padding: blockPadding }">
    <template v-if="isBuilderContext()">
      <div class="iframe-block__screenshot-overlay">
        <v-icon size="2.5rem" icon="open_in_browser" class="mb-1" />
        {{ getHostName(url) }} Embed
      </div>
    </template>
    <iframe
      :key="url"
      :class="[
        'iframe-block__iframe w-100',
        { '--readonly': isBuilderContext() }
      ]"
      width="100%"
      :style="{
        width: '100%',
        height: height,
        minHeight: height,
        minHeight: `calc(${height} + env(safe-area-inset-top))`
      }"
      :src="url"
      allowfullscreen
      allowtransparency
      allow="autoplay; fullscreen;clipboard-write; encrypted-media; picture-in-picture; web-share;"
    />
  </div>
</template>

<script>
import {
  withRatio,
  toPadding,
  BLOCK_DEFAULT_HEIGHT_RATIO
} from "@/lib/stream-utils"
import { isBuilderContext, getHostName } from "@/lib/utils"

const BLOCK_BASE_HEIGHT = 200

export default {
  props: {
    url: { type: String, default: null },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 },
    heightRatio: { type: Number, default: BLOCK_DEFAULT_HEIGHT_RATIO }
  },

  computed: {
    height() {
      return withRatio(BLOCK_BASE_HEIGHT, this.heightRatio)
    },

    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    }
  },

  methods: {
    withRatio,
    isBuilderContext,
    getHostName
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/mixins";

.iframe-block {
  @include container;
}

.iframe-block__iframe {
  overflow: hidden;
  min-height: 200px;
  border: none;

  &.--readonly {
    pointer-events: none;
  }
}

.iframe-block__screenshot-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px dashed $color-ui--grey-50;
  border-radius: 8px;
  color: $color-ui--grey-60;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: $font-size--large;
  font-weight: $font-weight--semi-bold;
  text-align: center;
  padding: 0 $size--5;
  z-index: 1;
  display: none;
}

[data-role="block"].block.--screenshotting {
  .iframe-block__screenshot-overlay {
    display: flex !important;
  }
}
</style>
